module.exports = __webpack_public_path__ + "static/img/png.be5e27db.png";